/**
 * 0.44.81 - IP access (Settings > IP access), the page side.
 *
 * The backend answers 403 to every API call from an address the rule
 * blocks. This gate asks once, before anything else loads, whether this
 * address may use the side of the site the page is on (the admin panel
 * on the admin hostname or under /admin and /login, the public site
 * elsewhere). Blocked: a bare "403 Forbidden" page, nothing else. A
 * network fault lets the page load: the
 * backend still refuses every call.
 */
import { appPath } from '../lib/basePath';
import { useEffect, useState } from 'react';
import { isAdminHost } from '../utils/adminHost';

function scopeOfPage() {
  const path = appPath() || '/';
  if (isAdminHost() || path === '/admin' || path.startsWith('/admin/') || path.startsWith('/login')) {
    return 'admin';
  }
  return 'public';
}

export default function AccessGate({ children }) {
  const [state, setState] = useState('checking');   // checking | ok | blocked
  useEffect(() => {
    let alive = true;
    fetch(`/api/public/access?scope=${scopeOfPage()}`, { credentials: 'include' })
      .then(r => { if (alive) setState(r.status === 403 ? 'blocked' : 'ok'); })
      .catch(() => { if (alive) setState('ok'); });
    return () => { alive = false; };
  }, []);
  useEffect(() => {
    if (state === 'blocked') document.title = '403 Forbidden';
  }, [state]);
  if (state === 'checking') return null;
  if (state === 'blocked') {
    return (
      <main style={{ fontFamily: 'var(--font-family-base)', textAlign: 'center', padding: '64px 16px',
                     color: 'var(--color-text-800)' }}>
        <h1 style={{ fontSize: 'var(--font-size-h2)', lineHeight: 'var(--line-height-h2-text)', margin: 0 }}>
          403 Forbidden
        </h1>
      </main>
    );
  }
  return children;
}
